import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export type UnitedStore = {
  stageScale: number;
  setStageScale: (scale: number) => void;
  updateStageScaleBy: (scale: number) => void;
};

type StoreMiddleware = [['zustand/devtools', never]];

export const useStageScaleStore = create<UnitedStore, StoreMiddleware>(
  devtools(
    set => ({
      stageScale: 1,
      setStageScale: scale => set(() => ({ stageScale: scale })),
      updateStageScaleBy: value =>
        set(state => ({
          //Needs to be rounded since javaScript floating point math is a little off sometimes
          stageScale: Math.round((state.stageScale + value) * 20) / 20
        }))
    }),
    { enabled: process.env.NODE_ENV !== 'production', name: 'Stage store' }
  )
);
